import { type FunctionComponent } from "react";
import { useStakeStore } from "../../state";
import type { Route } from "@types";

export const NavMenuItem: FunctionComponent<Route> = ({
  name,
  icon,
  asset,
  disabled,
  isExternal,
  route,
}) => {
  const { activeRoute, routeTo } = useStakeStore();

  const classes = (): string => {
    const active = activeRoute.name === "default" ? "Stake" : activeRoute.name;
    return [
      "menu-item",
      active === name ? "active" : "inactive",
      disabled ? "disabled" : null,
    ]
      .filter((v) => v)
      .join(" ");
  };

  const ImageFrame = () => (
    <div className="asset" style={{ backgroundImage: `url(${asset})` }} />
  );
  const resolvedIcon = () => {
    if (icon) {
      const Icon = icon;
      return <Icon />;
    }
    if (asset) {
      return <ImageFrame />;
    }
    return null;
  };

  return (
    <div
      key={`route-${name}`}
      className={classes()}
      onClick={() =>
        isExternal ? window.open(route, "_blank") : routeTo(name)
      }
    >
      <div className="icon">{resolvedIcon()}</div>
      <div className="link">
        <span className="label">{name}</span>
      </div>
    </div>
  );
};
